module.exports = __webpack_public_path__ + "37ba7b92/img/link-icon.fa09ed66.svg";